module.exports = __webpack_public_path__ + "static/media/talk.4b72a865.png";